import { Controller } from 'stimulus';
import Cookies from 'js-cookie';
import EzPopunder from 'components/ez-popunder';
import { triggerCustomEvent } from 'lib/helpers';
import events from 'lib/events';

export default class ShutterstockPopupController extends Controller {
  maybePagination() {
    this.mode = 'pagination';

    if (!this.recentlySeenPopup()) {
      triggerCustomEvent(events.sstk.pagination_popup, {});
      this.openPopup();
    }
  }

  maybeSearch() {
    this.mode = 'search';

    if (!this.recentlySeenPopup() && this.isLucky()) {
      triggerCustomEvent(events.sstk.search_popup, {
        subId1: this.sstkSubId1(),
      });

      this.openPopup();
    }
  }

  openPopup() {
    Cookies.set('sstkSearchPU', { lastSeen: Date.now() });

    // TODO: implement skip-sstk-popup, or is that a failed split test?
    const popup = new EzPopunder();
    popup.open(this.sstkUrl());
  }

  recentlySeenPopup() {
    const cookie = Cookies.getJSON('sstkSearchPU');

    if (!cookie) return false;

    const thirtyMinutes = 1000 * 60 * 30;
    const threshold = Date.now() - thirtyMinutes;

    return cookie.lastSeen > threshold;
  }

  isLucky() {
    // 3. The lucky number is 3.
    return this.randomNumber() === 3;
  }

  randomNumber() {
    // return a random number between 1 and 5, inclusively
    return Math.floor(Math.random() * 5) + 1;
  }

  get searchTerm() {
    const searchForm = document.querySelector("[data-controller~='search-form']");

    if (!searchForm) {
      return null;
    }

    const searchInput = searchForm.querySelector('input[name=search]');
    if (searchInput) {
      if (searchInput) {
        return searchInput.value;
      }
    }

    return searchForm.getAttribute('data-search-term');
  }

  sstkUrl() {
    switch (this.mode) {
      case 'search':
        return this.sstkSearchUrl();
      case 'pagination':
        return this.sstkPaginationUrl();
      default:
        return null;
    }
  }

  sstkSearchUrl() {
    const params = {
      subId1: encodeURIComponent(this.sstkSubId1()),
      subId2: encodeURIComponent(this.searchTerm),
      subId3: this.sstkSubId3(),
      u: encodeURIComponent(this.sstkRedirectUrl()),
      sharedid: window.location.hostname,
    };

    return `http://shutterstock.7eer.net/c/38919/111120/1305?${
      Object.keys(params).map(key => `${key}=${params[key]}`).join('&')}`;
  }

  sstkPaginationUrl() {
    const params = {
      subId1: 'pagination',
      subId2: encodeURIComponent(this.searchTerm),
      subId3: this.sstkSubId3(),
      u: encodeURIComponent(this.sstkRedirectUrl()),
      sharedid: window.location.hostname,
    };

    return `http://shutterstock.7eer.net/c/38919/111120/1305?${
      Object.keys(params).map(key => `${key}=${params[key]}`).join('&')}`;
  }

  sstkSubId1() {
    if (this.mode === 'pagination') {
      return 'pagination';
    }

    const { classList } = document.body;

    if (classList.contains('home-index')) {
      return 'SearchPopHome';
    }

    if (classList.contains('resources-show')) {
      return 'SearchPopShow';
    }

    if (classList.contains('searches-show')) {
      return 'SearchPopSearch';
    }

    return 'SearchPopOther';
  }

  sstkSubId3() {
    let value = Cookies.get('ga-client-id');
    if (this.isMobile()) {
      value += '|mobile';
    }
    return value;
  }

  sstkRedirectUrl() {
    const params = {
      searchterm: this.searchTerm,
      search_source: 'base_search_form',
      language: 'en',
      page: '1',
      sort: 'popular',
      image_type: 'vector',
      safe: 'true',
    };

    return `https://www.shutterstock.com/search?${
      Object.keys(params).map(key => `${key}=${params[key]}`).join('&')}`;
  }

  isMobile() {
    return document.body.classList.contains('is-mobile');
  }
}
